import { useEffect, useState } from "react";
import api, { formatApiError } from "@/utils/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const MfaSetupFlow = ({ onEnabled, onCancel }) => {
  const [setup, setSetup] = useState(null);
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.post("/auth/mfa/setup").then(({ data }) => setSetup(data))
      .catch((err) => setError(formatApiError(err.response?.data?.detail) || "Could not start setup"));
  }, []);

  const enable = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { const { data } = await api.post("/auth/mfa/enable", { code: code.trim() }); onEnabled(data.recovery_codes); }
    catch (err) { setError(formatApiError(err.response?.data?.detail) || "Code didn't match"); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-4" data-testid="mfa-setup-flow">
      {error && <div className="rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-700" data-testid="mfa-setup-error">{error}</div>}
      <ol className="list-decimal space-y-1 pl-5 text-sm text-slate-700">
        <li>Open <strong>Microsoft Authenticator</strong>, tap <strong>+</strong> then <strong>Other account</strong>.</li>
        <li>Scan the QR code below (or type the key in manually).</li>
        <li>Enter the 6-digit code the app shows.</li>
      </ol>
      {setup && (
        <div className="flex flex-col sm:flex-row gap-4 items-start">
          <img src={setup.qr_data_url} alt="MFA QR code" className="h-44 w-44 rounded-md border border-border" data-testid="mfa-qr-code" />
          <div className="space-y-1 text-xs">
            <p className="text-muted-foreground">Can't scan? Setup key:</p>
            <code className="block break-all rounded bg-slate-100 px-2 py-1 font-mono text-sm" data-testid="mfa-secret">{setup.secret.match(/.{1,4}/g).join(" ")}</code>
          </div>
        </div>
      )}
      <form onSubmit={enable} className="flex flex-wrap items-end gap-2">
        <div>
          <Label className="text-xs">6-digit code</Label>
          <Input value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} maxLength={6} inputMode="numeric" autoComplete="one-time-code" className="mt-1 w-36 font-mono tracking-widest" data-testid="mfa-setup-code-input" />
        </div>
        <Button type="submit" disabled={busy || code.length !== 6 || !setup} className="bg-slate-900 hover:bg-slate-800 text-white" data-testid="mfa-enable-btn">{busy ? "Checking…" : "Turn on"}</Button>
        <Button type="button" variant="ghost" onClick={onCancel} data-testid="mfa-setup-cancel-btn">Cancel</Button>
      </form>
    </div>
  );
};
